import { useEffect, useRef } from "react"
import { useSearchParams } from "react-router-dom"

import { KEY_VALUES } from "@/constants"
import { useAuth } from "@/contexts/auth"
const isValidAuthPayload = (payload: unknown): payload is LoginResponseType => {
  if (!payload || typeof payload !== "object") return false
  const candidate = payload as Partial<LoginResponseType>
  const hasAccessToken =
    typeof candidate?.accessToken === "string" &&
    candidate.accessToken.length > 0
  const user = candidate?.user as Partial<UserType> | undefined
  const hasUserData =
    !!user &&
    typeof user === "object" &&
    typeof user.merchantId === "string" &&
    typeof user.userId === "string" &&
    typeof user.fullName === "string"
  return hasAccessToken && hasUserData
}
export const SSOAuth = () => {
  const { handleUpdateAuthData } = useAuth()
  const [searchParams] = useSearchParams()
  const processedTokenRef = useRef<string | null>(null)
  useEffect(() => {
    const encodedToken = searchParams.get(KEY_VALUES.AUTH_SEARCH_PARAMS_KEY)
    if (!encodedToken || processedTokenRef.current === encodedToken) return
    try {
      const decodedPayload = atob(encodedToken)
      const authData = JSON.parse(decodedPayload)
      if (!isValidAuthPayload(authData)) return
      processedTokenRef.current = encodedToken
      handleUpdateAuthData(authData)
    } catch (error) {
      console.error("Failed to process SSO authentication payload", error)
      processedTokenRef.current = null
    }
  }, [searchParams, handleUpdateAuthData])
  return null
}
